import { DropdownMenu, Flex, IconicButton, DropdownButton as NDSDropdownButton, Text } from "@nulogy/components";
import { FLAG_OPTIONS, NO_FLAG } from "components/common/Scheduler/flagsConfig";
import WorkOrderFlag from "components/common/Scheduler/SchedulerRenderers/components/blocks/WorkOrderFlag";
import ConfirmModalContext from "contexts/ConfirmModalContext";
import useDeleteConfirmationModal from "hooks/state/useDeleteConfirmationModal";
import React, { useContext } from "react";
import styled from "styled-components";

const DropdownButton = styled(NDSDropdownButton)`
  white-space: nowrap;
`;

const DeleteWorkOrderButton = styled(DropdownButton)(({ theme }) => ({
  "&:hover": {
    color: theme.colors.red,
  },
}));

export default function WorkOrderCardMenu({
  onOpenWorkOrderDetails,
  onUnscheduleWorkOrder,
  updateWorkOrder,
  userCanUpdate,
  workOrder,
}) {
  const { code, id: workOrderId, unschedulable } = workOrder;
  const { open: openModal } = useDeleteConfirmationModal();
  const { confirmAction } = useContext(ConfirmModalContext);

  const handleUnschedule = () => {
    const message = `This action will unschedule all of the work order’s (${code}) scheduled blocks. However, it will not delete its published jobs, if any.`;

    confirmAction(message, "Unschedule", () => onUnscheduleWorkOrder({ workOrderId }), "Unschedule work order");
  };

  const handleRemove = () => {
    openModal(workOrder);
  };

  const handleUpdateFlag = (flag, closeMenu) => (e) => {
    updateWorkOrder({ flag, id: workOrderId });
    closeMenu(e);
  };

  function flagDropdownMenu(closeMenu) {
    return (
      <DropdownMenu
        openOnHover
        placement="left-start"
        showArrow={false}
        trigger={() => (
          <DropdownButton>
            <Flex justifyContent="space-between">
              <Text>Flags</Text>
              <Text>&gt;</Text>
            </Flex>
          </DropdownButton>
        )}
      >
        {Object.keys(FLAG_OPTIONS).map((flagOption) => (
          <DropdownButton
            className="pendo-add-flag-work-order-card-menu-item"
            key={flagOption}
            onClick={handleUpdateFlag(flagOption, closeMenu)}
          >
            <WorkOrderFlag flag={flagOption} size="large" />
          </DropdownButton>
        ))}
        <DropdownButton
          className="pendo-remove-flag-work-order-card-menu-item"
          onClick={handleUpdateFlag(NO_FLAG, closeMenu)}
        >
          Remove flag
        </DropdownButton>
      </DropdownMenu>
    );
  }

  const renderContextMenu = (closeMenu) => (
    <>
      <DropdownButton
        className="pendo-view-work-order-details-work-order-card-menu-item"
        onClick={(e) => {
          onOpenWorkOrderDetails();
          closeMenu(e);
        }}
      >
        View details and notes
      </DropdownButton>

      {userCanUpdate && (
        <>
          {flagDropdownMenu(closeMenu)}
          <DropdownButton
            className="spec-unschedule-work-order-button pendo-unschedule-work-order-work-order-card-menu-item"
            disabled={!unschedulable}
            onClick={(e) => {
              handleUnschedule();
              closeMenu(e);
            }}
          >
            Unschedule work order
          </DropdownButton>
          <DeleteWorkOrderButton
            className="pendo-delete-work-order-work-order-card-menu-item"
            onClick={(e) => {
              handleRemove();
              closeMenu(e);
            }}
          >
            Delete work order
          </DeleteWorkOrderButton>
        </>
      )}
    </>
  );

  return (
    <DropdownMenu
      placement="bottom-end"
      trigger={() => <IconicButton className="pendo-work-order-card-menu" data-testid="context-menu" icon="more" />}
    >
      {({ closeMenu }) => renderContextMenu(closeMenu)}
    </DropdownMenu>
  );
}
